import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Avatar, { AvatarGroup } from 'components/common/Avatar';
import { Dropdown, Form, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from 'components/common/Flex';
import { Link } from 'react-router-dom';
import AppContext from 'context/Context';

const GroupUser = ({
  avatarSize = 'l',
  users,
  showMember = 4,
  addMember,
  className,
  showName
}) => {
  const {
    config: { isRTL }
  } = useContext(AppContext);
  const [searchTerm, setSearchTerm] = useState('');
  return (
    <div className={className}>
      <AvatarGroup>
        {users.slice(0, showMember).map((user, index) => (
          <Dropdown key={user.userId}>
            <Dropdown.Toggle
              as={Nav.Link}
              className={classNames('dropdown-caret-none p-0', {
                'ms-n1': index > 0
              })}
            >
              <div className="position-relative">
                <div className="position-relative">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`member-${user.userId}`}>{user.name}</Tooltip>
                    }
                  >
                    <div className="">
                    <Flex alignItems="center" className={showName ? 'px-3' : ''}>
                      {user.img ? (
                        <Avatar src={user.img} size={avatarSize} />
                      ) : (
                        <Avatar name={user.login} size={avatarSize} />
                      )}
                      {showName && (
                        <div className="flex-1 px-1">
                          <h6 className="mb-0">
                            {/* <Link className="text-900" to="/user/profile"> */}
                              {user.name}
                            {/* </Link> */}
                          </h6>
                          <p className="fs--2 mb-0 text-500">{user.role}</p>
                        </div>
                      )}
                       </Flex>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu
              align={isRTL ? 'end' : 'start'}
              className="dropdown-md px-0 py-3"
            >
              <Flex alignItems="center" className="px-3">
                {/* <Link to="/user/profile"> */}
                  {user.img ? (
                    <Avatar src={user.img} className="me-2" size="2xl" />
                  ) : (
                    <Avatar name={user.login} className="me-2" size="2xl" />
                  )}
                  {/* <Avatar src={user.img} className="me-2" size="2xl" /> */}
                {/* </Link> */}
                <div className="flex-1">
                  <h6 className="mb-0">
                    {/* <Link className="text-900" to="/user/profile"> */}
                      {user.name}
                    {/* </Link> */}
                  </h6>
                  <p className="fs--2 mb-0 text-500">{user.role}</p>
                </div>
              </Flex>
            </Dropdown.Menu>
          </Dropdown>
        ))}
        {(users.length > showMember || addMember) && (
          <Dropdown>
            <Dropdown.Toggle
              as={Nav.Link}
              className="dropdown-caret-none p-0 ms-n1"
            >
              {!addMember ? (
                <Avatar
                  name={`${users.length - showMember}+`}
                  size={avatarSize}
                  isExact
                  mediaClass="avatar-button"
                />
              ) : (
                <Avatar
                  icon="plus"
                  size={avatarSize}
                  mediaClass="avatar-button flex-center"
                />
              )}
            </Dropdown.Toggle>

            <Dropdown.Menu
              align={isRTL ? 'end' : 'start'}
              className="dropdown-md"
            >
              <h6 className="dropdown-header py-0 px-3 mb-0">
                {!addMember ? 'Users' : 'Select Member'}
              </h6>
              <Dropdown.Divider />
              {!addMember ? (
                <Flex className="px-3">
                  {users.map(user => (
                      <div className="position-relative" key={user.userId}>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`member-${user.userId}`}>
                              {user.name}
                            </Tooltip>
                          }
                        >
                          <div className="">
                            {user.img ? (
                              <Avatar
                                src={user.img}
                                className="me-2"
                                size="xl"
                              />
                            ) : (
                              <Avatar
                                name={user.login}
                                className="me-2"
                                size="xl"
                              />
                            )}
                            {/* <Avatar src={user.img} className="me-2" size="xl" /> */}
                          </div>
                        </OverlayTrigger>
                      </div>
                  ))}
                </Flex>
              ) : (
                <>
                  <Form className="px-3 mb-2">
                    <Form.Control
                      size="sm"
                      type="text"
                      placeholder="Search team member"
                      onChange={e => setSearchTerm(e.target.value)}
                    />
                  </Form>
                  <ul className="list-unstyled mb-0">
                    {users
                      .filter(user => {
                        if (!searchTerm) {
                          return user;
                        } else if (
                          user.name
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase().trim())
                        ) {
                          return user;
                        }
                      })
                      .map(user => (
                        <li key={user.userId}>
                          <Link to="#!">
                            <Flex
                              alignItems="center"
                              className="px-3 py-1 text-decoration-none"
                            >
                              <Avatar
                                src={user.img}
                                className="me-2"
                                size={avatarSize}
                              />
                              <div className="flex-1">
                                <h6 className="mb-0">{user.name}</h6>
                              </div>
                            </Flex>
                          </Link>
                        </li>
                      ))}
                  </ul>
                </>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </AvatarGroup>
    </div>
  );
};

GroupUser.propTypes = {
  avatarSize: PropTypes.string,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      img: PropTypes.string,
      role: PropTypes.string
    })
  ).isRequired,
  showName: PropTypes.bool,
  showMember: PropTypes.number,
  addMember: PropTypes.bool,
  className: PropTypes.string
};

export default GroupUser;
